import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'
import moment from 'moment'

const getDefaultStateForLocations = () => {
    return {
        locations: [],
        from_warehouses:[],
        to_warehouses:[],
        all_locations:[],
        warehouses:[],
        data: {},
        is_customer_added: null,
        is_created: null,
        is_updated: null,
        is_deleted: null,
        is_retrieve: null,
        active_locations:[],
        filter: {
            keyword: "",
            active_only: "1"
        }
    }
}


// state
const state = getDefaultStateForLocations()

// getters
const getters = {

}

// mutations
const mutations = {
    FETCH_ACTIVE(state, data){

        if(data.data)
        {

            if(data.code == '_new')
            {
                state.active_locations = data.data
            }
            else
            {
                let arr = data.data
                state.active_locations = arr
            }

        }
    },
    RESET_STATE_FOR_LOCATION (state) {
        Object.assign(state, getDefaultStateForLocations())
    },
    QUICK_SEARCH(state, data) {
        data.forEach(function(element) {
            element.time_created = (element.time_created != null && element.time_created != '') ? (moment(element.time_created).format('DD/MM/YYYY, h:mm a')) : '-'
        });
        state.locations = data

    },
    SET_FILTER(state, data) {
        state.filter = data
    },
    SET_IS_CREATED(state, data) {
        state.is_created = data
    },
    SET_IS_UPDATED(state, data) {
        state.is_updated = data
    },
    SET_IS_DELETED(state, data) {
        state.is_deleted = data
    },
    FETCH(state, data) {
        if (data) {
            state.data = data
        }
    },
    SET_ALL_LOCATIONS(state, data){
        if(data)
        {
            state.all_locations = data
        }
    },
    SET_FROM_WAREHOUSES(state, data){
        if (data) {
            state.from_warehouses = data
        }
    },
    SET_TO_WAREHOUSES(state, data){
        if (data) {
            state.to_warehouses = data
        }
    },
    FETCH_WAREHOUSES(state, data) {
        if (data) {
            state.warehouses = data
        }
    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_LOCATION")
    },
    listFromWarehouses({commit}, data) {
        return axios.post(apiRoutes['LIST_FROM_WAREHOUSES'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('SET_FROM_WAREHOUSES', response.data.data)
          } else {
            commit('SET_FROM_WAREHOUSES', [])
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    listToWarehouses({commit}, data) {
        return axios.post(apiRoutes['LIST_TO_WAREHOUSES'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('SET_TO_WAREHOUSES', response.data.data)
          } else {
            commit('SET_TO_WAREHOUSES', [])
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    listLocations({commit}, data) {
        return axios.post(apiRoutes['LIST_ALL_LOCATIONS'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('SET_ALL_LOCATIONS', response.data.data)
          } else {
            commit('SET_ALL_LOCATIONS', [])
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    listAllLocations({commit}, data) {
        return axios.post(apiRoutes['LOCATION_ACTIVE_LIST'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('FETCH_ACTIVE', {data:response.data.data, code:data.code})
          } else {
            commit('FETCH_ACTIVE', {data:[], code:data.code})
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['LOCATION_QUICK_SEARCH'], data, authHeader())
            .then(response => {
                if (response.data.code == 1) {
                    commit('QUICK_SEARCH', response.data.data)
                    commit('SET_FILTER', data)
                } else {
                    commit('QUICK_SEARCH', [])
                    commit('SET_FILTER', data)
                }
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem Searching", error);
                }
            });
    },
    async create({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['CREATE_LOCATION'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let doc_number = response.data.data.code
                    commit('SET_IS_CREATED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Location (' + doc_number + ')' + " has been created!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } 
                else 
                {
                    let errors = response.data.data.errors
                    if (Array.isArray(errors)) {
                        let msg = errors.join("\n")
                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }
                    commit('SET_IS_CREATED', 0);

                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Application Error")
                }
            });
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['RETRIEVE_LOCATION'], data, authHeader())
            .then(response => {
                if (response.data.code == 1) {
                    commit('FETCH', response.data.data)
                } else {
                    commit('FETCH', {})
                }
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem Querying Data!", error);
                }
            });
    },
    async update({ commit, dispatch }, data) {
        await axios.post(apiRoutes['UPDATE_LOCATION'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let doc_number = response.data.data.code
                    commit('SET_IS_UPDATED', 1);

                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Location (' + doc_number + ')' + " has been updated!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } 
                else 
                {
                    let errors = response.data.data.errors
                    commit('SET_IS_UPDATED', 0);
                    if (Array.isArray(errors)) {
                        console.log(errors)
                        let msg = errors.join("\n")

                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }


                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Creating Sale Channel")
                }
            });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_SALE_CHANNEL'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let doc_number = response.data.data.code
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Sale Channel (' + doc_number + ')' + " has been deleted!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                    commit('SET_IS_DELETED', 1);
                } else {
                    let errors = response.data.data.errors

                    if (Array.isArray(errors)) {
                        let msg = errors.join("\n")

                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }
                    commit('SET_IS_DELETED', 0);
                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Creating Sale Channel")
                }
            });
    },
    async fetchActive({ commit }, data)
    {
        return axios.post(apiRoutes['LOCATION_ACTIVE_LIST'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('FETCH_ACTIVE', {data:response.data.data, code:data.code})
          } else {
            commit('FETCH_ACTIVE', {data:[], code:data.code})
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
    },
    async fetchWarehouses({ commit }, data) {
        return axios.post(apiRoutes['LIST_WAREHOUSES'], data, authHeader())
            .then(response => {
                if (response.data.code == 1) {
                    commit('FETCH_WAREHOUSES', response.data.data)
                    con
                } else {
                    commit('FETCH_WAREHOUSES', [])
                }
            })
            .catch(error => {
                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem Querying Data!", error);
                }
            });
    },

}

export {
    state,
    getters,
    actions,
    mutations
}